export default {
    methods: {
        redirectToAppLogin() {
            if (process.env.NODE_ENV == 'production') {
                try {
                    native.openWindow(JSON.stringify({
                        url:'/index/index.html#/app/login'
                    }))

                    this.refreshWhenPageVisible()
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.refreshWhenPageVisible()
            }
        },

        refreshWhenPageVisible() {
            var hidden, visibilityChange;

            if (typeof document.hidden !== "undefined") {
                hidden = "hidden";
                visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden";
                visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden";
                visibilityChange = "webkitvisibilitychange";
            }

            if (typeof document.addEventListener === "undefined" || hidden === undefined) {
                this.openRefreshDialog()
            } else {
                document.addEventListener(visibilityChange, () => {
                    if (document.visibilityState === 'visible') {
                        location.reload()
                    }
                });
            }
        },

        openRefreshDialog() {
            Swal.fire({
                title: '請更新此頁面',
                confirmButtonText: `更新`,
            }).then((result) => {
                location.reload()
            })
        },
    }
}
